import { Grid } from "@mui/material";
import { Input, Space } from "antd";
import { useWorkflowStoreEmptyZero } from "../../../store";
import {
  AddonBefore,
  DividerComponent,
  ScanComponent,
} from "../../../../../libs/shared";
import { useScan } from "../../../../../libs/hooks";

export const SecondComponent =({ widthFull }: { widthFull: string }) => {
  return (
    <Grid
      container
      spacing={2}
      justifyContent="flex-start"
      alignContent="flex-start"
      alignItems="flex-start"
      sx={{
        minHeight: `calc(100vh - 105px)`,
        maxHeight: `calc(100vh - 105px)`,
        height: `calc(100vh - 105px)`,
        overflowY: "auto",
        overflowX: "hidden",
        position: "relative",
        pt: 6,
        pb: 2,
        width: "100%",
      }}
    >
      <DocumentsComponent width={widthFull} />
      <SellosArriboVerficadoraComponent width={widthFull} />
      <SellosArriboExportadorComponent width={widthFull} />
    </Grid>
  );
}

//DOCUMENTOS
const DocumentsComponent = ({ width }: { width: string }) => {
  return (
    <>
      <DividerComponent label="DOCUMENTOS" />
      <EirComponent width={width} />
      <CiConductorComponent width={width} />
    </>
  );
};

const EirComponent = ({ width }: { width: string }) => {
  const eir = useWorkflowStoreEmptyZero((state) => state.eir);
  const setEir = useWorkflowStoreEmptyZero((state) => state.setEir);

  return (
    <>
      <Grid item xs={12}>
        <Input
          addonBefore={<AddonBefore label="EIR" width={width} />}
          value={eir || ""}
          onChange={(e) => setEir(e.target.value)}
          size={width === "xs" ? "middle" : "large"}
        />
      </Grid>
    </>
  );
};

const CiConductorComponent = ({ width }: { width: string }) => {
  const ciConductor = useWorkflowStoreEmptyZero((state) => state.ciConductor);
  const setCiConductor = useWorkflowStoreEmptyZero((state) => state.setCiConductor);

  return (
    <>
      <Grid item xs={12}>
        <Input
          addonBefore={
            <AddonBefore label="IDENTIFICACIÓN CONDUCTOR" width={width} />
          }
          value={ciConductor || ""}
          onChange={(e) => setCiConductor(e.target.value)}
          size={width === "xs" ? "middle" : "large"}
        />
      </Grid>
    </>
  );
};

// SELLOS ARRIBO VERIFICADORA
const SellosArriboVerficadoraComponent = ({ width }: { width: string }) => {
  return (
    <>
      <DividerComponent label="SELLOS ARRIBO VERIFICADORA" />
      <EtiquetaPuertaComponent width={width} />
      {/* <EtiquetaVentoleraComponent width={width} /> */}
      {/* <EtiquetaPanelExteriorComponent width={width} /> */}
      <SelloPlasticoComponent width={width} />
      <BotellaRastreoComponent width={width} />
      <NumRastreoComponent width={width} />
    </>
  );
};

const EtiquetaPuertaComponent = ({ width }: { width: string }) => {
  const etiquetaVerificadoraPuerta = useWorkflowStoreEmptyZero(
    (state) => state.etiquetaVerificadoraPuerta
  );
  const setEtiquetaVerificadoraPuerta = useWorkflowStoreEmptyZero(
    (state) => state.setEtiquetaVerificadoraPuerta
  );

  const {
    showScanQr,
    openScanQr,
    showScanBarCode,
    openScanBarCode,
    handleCloseQr,
    handleCloseBarCode,
    handleOpenQr,
    handleOpenBarCode,
  } = useScan();

  const handleSetQr = (val: string) => {
    setEtiquetaVerificadoraPuerta(val);
  };

  return (
    <>
      <Grid item xs={12}>
        <Space.Compact style={{ width: "100%" }}>
          <Input
            addonBefore={<AddonBefore label="ETIQUETA PUERTA" width={width} />}
            value={etiquetaVerificadoraPuerta || ""}
            onChange={(e) => setEtiquetaVerificadoraPuerta(e.target.value)}
            size={width === "xs" ? "middle" : "large"}
          />
          <ScanComponent
            handleOpenQr={handleOpenQr}
            handleOpenBarCode={handleOpenBarCode}
            width={width}
            showScanQr={showScanQr}
            handleSetQr={handleSetQr}
            openScanQr={openScanQr}
            handleCloseQr={handleCloseQr}
            showScanBarCode={showScanBarCode}
            openScanBarCode={openScanBarCode}
            handleCloseBarCode={handleCloseBarCode}
          />
        </Space.Compact>
      </Grid>
    </>
  );
};

const EtiquetaVentoleraComponent = ({ width }: { width: string }) => {
  const etiquetasVentoleras = useWorkflowStoreEmptyZero(
    (state) => state.etiquetasVentoleras
  );
  const setEtiquetasVentoleras = useWorkflowStoreEmptyZero(
    (state) => state.setEtiquetasVentoleras
  );

  const {
    showScanQr,
    openScanQr,
    showScanBarCode,
    openScanBarCode,
    handleCloseQr,
    handleCloseBarCode,
    handleOpenQr,
    handleOpenBarCode,
  } = useScan();

  const handleSetQr = (val: string) => {
    setEtiquetasVentoleras(val);
  };

  return (
    <>
      <Grid item xs={12}>
        <Space.Compact style={{ width: "100%" }}>
          <Input
            addonBefore={
              <AddonBefore label="ETIQUETAS VENTOLERAS" width={width} />
            }
            value={etiquetasVentoleras || ""}
            onChange={(e) => setEtiquetasVentoleras(e.target.value)}
            size={width === "xs" ? "middle" : "large"}
          />
          <ScanComponent
            handleOpenQr={handleOpenQr}
            handleOpenBarCode={handleOpenBarCode}
            width={width}
            showScanQr={showScanQr}
            handleSetQr={handleSetQr}
            openScanQr={openScanQr}
            handleCloseQr={handleCloseQr}
            showScanBarCode={showScanBarCode}
            openScanBarCode={openScanBarCode}
            handleCloseBarCode={handleCloseBarCode}
          />
        </Space.Compact>
      </Grid>
    </>
  );
};

const EtiquetaPanelExteriorComponent = ({ width }: { width: string }) => {
  const etiquetasPanelExterior = useWorkflowStoreEmptyZero(
    (state) => state.etiquetasPanelExterior
  );
  const setEtiquetasPanelExterior = useWorkflowStoreEmptyZero(
    (state) => state.setEtiquetasPanelExterior
  );

  const {
    showScanQr,
    openScanQr,
    showScanBarCode,
    openScanBarCode,
    handleCloseQr,
    handleCloseBarCode,
    handleOpenQr,
    handleOpenBarCode,
  } = useScan();

  const handleSetQr = (val: string) => {
    setEtiquetasPanelExterior(val);
  };

  return (
    <>
      <Grid item xs={12}>
      <Space.Compact style={{ width: "100%" }}>
        <Input
          addonBefore={
            <AddonBefore label="ETIQUETA PANEL EXTERIOR" width={width} />
          }
          value={etiquetasPanelExterior || ""}
          onChange={(e) => setEtiquetasPanelExterior(e.target.value)}
          size={width === "xs" ? "middle" : "large"}
        />
        <ScanComponent
            handleOpenQr={handleOpenQr}
            handleOpenBarCode={handleOpenBarCode}
            width={width}
            showScanQr={showScanQr}
            handleSetQr={handleSetQr}
            openScanQr={openScanQr}
            handleCloseQr={handleCloseQr}
            showScanBarCode={showScanBarCode}
            openScanBarCode={openScanBarCode}
            handleCloseBarCode={handleCloseBarCode}
          />
        </Space.Compact>
      </Grid>
    </>
  );
};

const SelloPlasticoComponent = ({ width }: { width: string }) => {
  const plastico = useWorkflowStoreEmptyZero((state) => state.plastico);
  const setPlastico = useWorkflowStoreEmptyZero((state) => state.setPlastico);

  const {
    showScanQr,
    openScanQr,
    showScanBarCode,
    openScanBarCode,
    handleCloseQr,
    handleCloseBarCode,
    handleOpenQr,
    handleOpenBarCode,
  } = useScan();

  const handleSetQr = (val: string) => {
    setPlastico(val);
  };

  return (
    <>
      <Grid item xs={12}>
      <Space.Compact style={{ width: "100%" }}>
        <Input
          addonBefore={<AddonBefore label="SELLO PLÁSTICO" width={width} />}
          value={plastico || ""}
          onChange={(e) => setPlastico(e.target.value)}
          size={width === "xs" ? "middle" : "large"}
        />
        <ScanComponent
            handleOpenQr={handleOpenQr}
            handleOpenBarCode={handleOpenBarCode}
            width={width}
            showScanQr={showScanQr}
            handleSetQr={handleSetQr}
            openScanQr={openScanQr}
            handleCloseQr={handleCloseQr}
            showScanBarCode={showScanBarCode}
            openScanBarCode={openScanBarCode}
            handleCloseBarCode={handleCloseBarCode}
          />
        </Space.Compact>
      </Grid>
    </>
  );
};

const BotellaRastreoComponent = ({ width }: { width: string }) => {
  const botellaRastreo = useWorkflowStoreEmptyZero((state) => state.botellaRastreo);
  const setBotellaRastreo = useWorkflowStoreEmptyZero(
    (state) => state.setBotellaRastreo
  );

  const {
    showScanQr,
    openScanQr,
    showScanBarCode,
    openScanBarCode,
    handleCloseQr,
    handleCloseBarCode,
    handleOpenQr,
    handleOpenBarCode,
  } = useScan();

  const handleSetQr = (val: string) => {
    setBotellaRastreo(val);
  };

  return (
    <>
      <Grid item xs={12}>
      <Space.Compact style={{ width: "100%" }}>
        <Input
          addonBefore={<AddonBefore label="SELLO RASTREO" width={width} />}
          value={botellaRastreo || ""}
          onChange={(e) => setBotellaRastreo(e.target.value)}
          size={width === "xs" ? "middle" : "large"}
        />
        <ScanComponent
            handleOpenQr={handleOpenQr}
            handleOpenBarCode={handleOpenBarCode}
            width={width}
            showScanQr={showScanQr}
            handleSetQr={handleSetQr}
            openScanQr={openScanQr}
            handleCloseQr={handleCloseQr}
            showScanBarCode={showScanBarCode}
            openScanBarCode={openScanBarCode}
            handleCloseBarCode={handleCloseBarCode}
          />
        </Space.Compact>
      </Grid>
    </>
  );
};

const NumRastreoComponent = ({ width }: { width: string }) => {
  const numRastreoSatelital = useWorkflowStoreEmptyZero(
    (state) => state.numRastreoSatelital
  );
  const setNumRastreoSatelital = useWorkflowStoreEmptyZero(
    (state) => state.setNumRastreoSatelital
  );

  const {
    showScanQr,
    openScanQr,
    showScanBarCode,
    openScanBarCode,
    handleCloseQr,
    handleCloseBarCode,
    handleOpenQr,
    handleOpenBarCode,
  } = useScan();

  const handleSetQr = (val: string) => {
    setNumRastreoSatelital(val);
  };

  return (
    <>
      <Grid item xs={12}>
      <Space.Compact style={{ width: "100%" }}>
        <Input
          addonBefore={<AddonBefore label="N° RASTREO" width={width} />}
          value={numRastreoSatelital || ""}
          onChange={(e) => setNumRastreoSatelital(e.target.value)}
          size={width === "xs" ? "middle" : "large"}
        />
        <ScanComponent
            handleOpenQr={handleOpenQr}
            handleOpenBarCode={handleOpenBarCode}
            width={width}
            showScanQr={showScanQr}
            handleSetQr={handleSetQr}
            openScanQr={openScanQr}
            handleCloseQr={handleCloseQr}
            showScanBarCode={showScanBarCode}
            openScanBarCode={openScanBarCode}
            handleCloseBarCode={handleCloseBarCode}
          />
        </Space.Compact>
      </Grid>
    </>
  );
};

// SELLOS ARRIBO EXPORTADOR
const SellosArriboExportadorComponent = ({ width }: { width: string }) => {
  return (
    <>
      <DividerComponent label="SELLOS ARRIBO EXPORTADORA" />
      <NumeroKitComponent width={width} />
      <EtiquetaExporPuertaComponent width={width} />
      <EtiquetaMacroEtiquetasVentolerasComponent width={width} />
      {/* <EtiquetaVentolerasAdicional width={width} /> */}
      <EtiquetaPanelExteriorExpComponent width={width} />
    </>
  );
};

const NumeroKitComponent = ({ width }: { width: string }) => {
  const numKit = useWorkflowStoreEmptyZero((state) => state.numKit);
  const setNumKit = useWorkflowStoreEmptyZero((state) => state.setNumKit);

  return (
    <>
      <Grid item xs={12}>
        <Input
          addonBefore={<AddonBefore label="N° KIT" width={width} />}
          value={numKit || ""}
          onChange={(e) => setNumKit(e.target.value)}
          size={width === "xs" ? "middle" : "large"}
        />
      </Grid>
    </>
  );
};

const EtiquetaExporPuertaComponent = ({ width }: { width: string }) => {
  const etiquetaExporPuerta = useWorkflowStoreEmptyZero(
    (state) => state.etiquetaExporPuerta
  );
  const setEtiquetaExporPuerta = useWorkflowStoreEmptyZero(
    (state) => state.setEtiquetaExporPuerta
  );

  const {
    showScanQr,
    openScanQr,
    showScanBarCode,
    openScanBarCode,
    handleCloseQr,
    handleCloseBarCode,
    handleOpenQr,
    handleOpenBarCode,
  } = useScan();

  const handleSetQr = (val: string) => {
    setEtiquetaExporPuerta(val);
  };

  return (
    <>
      <Grid item xs={12}>
      <Space.Compact style={{ width: "100%" }}>
        <Input
          addonBefore={<AddonBefore label="ETIQUETA PUERTA" width={width} />}
          value={etiquetaExporPuerta || ""}
          onChange={(e) => setEtiquetaExporPuerta(e.target.value)}
          size={width === "xs" ? "middle" : "large"}
        />
        <ScanComponent
            handleOpenQr={handleOpenQr}
            handleOpenBarCode={handleOpenBarCode}
            width={width}
            showScanQr={showScanQr}
            handleSetQr={handleSetQr}
            openScanQr={openScanQr}
            handleCloseQr={handleCloseQr}
            showScanBarCode={showScanBarCode}
            openScanBarCode={openScanBarCode}
            handleCloseBarCode={handleCloseBarCode}
          />
        </Space.Compact>
      </Grid>
    </>
  );
};

const EtiquetaMacroEtiquetasVentolerasComponent = ({
  width,
}: {
  width: string;
}) => {
  const macroEtiquetasVentoleras = useWorkflowStoreEmptyZero(
    (state) => state.macroEtiquetasVentoleras
  );
  const setMacroEtiquetasVentoleras = useWorkflowStoreEmptyZero(
    (state) => state.setMacroEtiquetasVentoleras
  );

  const {
    showScanQr,
    openScanQr,
    showScanBarCode,
    openScanBarCode,
    handleCloseQr,
    handleCloseBarCode,
    handleOpenQr,
    handleOpenBarCode,
  } = useScan();

  const handleSetQr = (val: string) => {
    setMacroEtiquetasVentoleras(val);
  };

  return (
    <>
      <Grid item xs={12}>
      <Space.Compact style={{ width: "100%" }}>
        <Input
          addonBefore={
            <AddonBefore label="MACRO ETIQUETAS VENTOLERAS" width={width} />
          }
          value={macroEtiquetasVentoleras || ""}
          onChange={(e) => setMacroEtiquetasVentoleras(e.target.value)}
          size={width === "xs" ? "middle" : "large"}
        />
        <ScanComponent
            handleOpenQr={handleOpenQr}
            handleOpenBarCode={handleOpenBarCode}
            width={width}
            showScanQr={showScanQr}
            handleSetQr={handleSetQr}
            openScanQr={openScanQr}
            handleCloseQr={handleCloseQr}
            showScanBarCode={showScanBarCode}
            openScanBarCode={openScanBarCode}
            handleCloseBarCode={handleCloseBarCode}
          />
        </Space.Compact>
      </Grid>
    </>
  );
};

const EtiquetaVentolerasAdicional = ({ width }: { width: string }) => {
  const setMacroEtiquetasVentolerasAdicional = useWorkflowStoreEmptyZero(
    (state) => state.setMacroEtiquetasVentolerasAdicional
  );
  const macroEtiquetasVentolerasAdicional = useWorkflowStoreEmptyZero(
    (state) => state.macroEtiquetasVentolerasAdicional
  );

  const {
    showScanQr,
    openScanQr,
    showScanBarCode,
    openScanBarCode,
    handleCloseQr,
    handleCloseBarCode,
    handleOpenQr,
    handleOpenBarCode,
  } = useScan();

  const handleSetQr = (val: string) => {
    setMacroEtiquetasVentolerasAdicional(val);
  };

  return (
    <>
      <Grid item xs={12}>
      <Space.Compact style={{ width: "100%" }}>
        <Input
          addonBefore={
            <AddonBefore label="MACRO ETIQUETAS VENTOLERAS AD." width={width} />
          }
          value={macroEtiquetasVentolerasAdicional || ""}
          onChange={(e) => setMacroEtiquetasVentolerasAdicional(e.target.value)}
          size={width === "xs" ? "middle" : "large"}
        />
        <ScanComponent
            handleOpenQr={handleOpenQr}
            handleOpenBarCode={handleOpenBarCode}
            width={width}
            showScanQr={showScanQr}
            handleSetQr={handleSetQr}
            openScanQr={openScanQr}
            handleCloseQr={handleCloseQr}
            showScanBarCode={showScanBarCode}
            openScanBarCode={openScanBarCode}
            handleCloseBarCode={handleCloseBarCode}
          />
        </Space.Compact>
      </Grid>
    </>
  );
};

const EtiquetaPanelExteriorExpComponent = ({ width }: { width: string }) => {
  const etiquetasPanelExteriorExp = useWorkflowStoreEmptyZero(
    (state) => state.etiquetasPanelExteriorExp
  );
  const setEtiquetasPanelExteriorExp = useWorkflowStoreEmptyZero(
    (state) => state.setEtiquetasPanelExteriorExp
  );

  const {
    showScanQr,
    openScanQr,
    showScanBarCode,
    openScanBarCode,
    handleCloseQr,
    handleCloseBarCode,
    handleOpenQr,
    handleOpenBarCode,
  } = useScan();

  const handleSetQr = (val: string) => {
    setEtiquetasPanelExteriorExp(val);
  };
  
  return (
    <>
      <Grid item xs={12}>
      <Space.Compact style={{ width: "100%" }}>
        <Input
          addonBefore={
            <AddonBefore label="ETIQUETA PANEL EXTERIOR" width={width} />
          }
          value={etiquetasPanelExteriorExp || ""}
          onChange={(e) => setEtiquetasPanelExteriorExp(e.target.value)}
          size={width === "xs" ? "middle" : "large"}
        />
        <ScanComponent
            handleOpenQr={handleOpenQr}
            handleOpenBarCode={handleOpenBarCode}
            width={width}
            showScanQr={showScanQr}
            handleSetQr={handleSetQr}
            openScanQr={openScanQr}
            handleCloseQr={handleCloseQr}
            showScanBarCode={showScanBarCode}
            openScanBarCode={openScanBarCode}
            handleCloseBarCode={handleCloseBarCode}
          />
        </Space.Compact>
      </Grid>
    </>
  );
};
